module.exports = __webpack_public_path__ + "img/Citibank.ad186fa3.png";